import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import setSpacesInText from '@functions/setSpacesInText.ts';

import I from '../types.ts';

const renderQuestions: I['renderQuestions'] = function () {
    const { currentQuestion, heights } = this.state;

    return (
        <div className="publicExecutorsFaq__content">
            {this.questions.map((question, key) => (
                <div
                    className={`publicExecutorsFaq__card _click ${
                        currentQuestion === key ? '_active' : ''
                    }`}
                    key={key}
                    data-key={key}
                    onClick={() => {
                        this.questionHandler(key);
                    }}
                >
                    <div className="publicExecutorsFaq__cardInner">
                        <div className="publicExecutorsFaq__cardHead">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: setSpacesInText(question.title),
                                }}
                            ></span>
                            <div className="publicExecutorsFaq__cardHeadIcon _col">
                                <i className="publicExecutorsFaq__cardHeadIconItem">
                                    <Icon name="public-plus" />
                                </i>
                            </div>
                        </div>
                        <div
                            className="publicExecutorsFaq__cardContent"
                            style={
                                currentQuestion === key
                                    ? { height: `${heights[key]}px` }
                                    : { height: 0 }
                            }
                        >
                            <div
                                className="publicExecutorsFaq__cardContentInner"
                                dangerouslySetInnerHTML={{
                                    __html: setSpacesInText(question.content),
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default renderQuestions;
